import * as Yup from 'yup'

const yupLogin = Yup.object().shape({
  companyID: Yup.string().required('Plese Enter'),
  email: Yup.string().email('Not a proper email').required('Plese Enter'),
  password: Yup.string().required('Plese Enter'),
})

export default yupLogin
